import { render, staticRenderFns } from "./ItemPane.vue?vue&type=template&id=86859e70&"
import script from "./ItemPane.vue?vue&type=script&lang=ts&"
export * from "./ItemPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports